import React, { isValidElement } from 'react'
import { DialogActions, DialogContent, DialogTitle, Grid, Icon, IconButton } from '@mui/material'
import { styled } from '@mui/material/styles'
import PropTypes from 'prop-types'
import { isUndefined } from 'lodash'
import { mainBlue } from 'utils/constants/ColorTheme'
import Action from 'components/action/Action'

const DefaultDialogTitle = ({
    title = '',
    onClose = '',
}) => {
    return (
        <DialogTitle>
            <Grid container justifyContent='space-between' alignItems='center'>
                <Grid size='grow'>
                    {title}
                </Grid>
                <Grid size='auto'>
                    <IconButton onClick={onClose} sx={{ fontSize: '2rem' }}>
                        <Icon sx={{ color: 'white', fontSize: 'inherit' }}>close</Icon>
                    </IconButton>
                </Grid>
            </Grid>
        </DialogTitle>
    )
}

DefaultDialogTitle.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    onClose: PropTypes.func,
}

export const DialogActionsTitle = ({
    title = '',
    actions = [],
}) => {
    const filteredActions = actions.filter(a => a.displayed || isUndefined(a.displayed))
    return (
        <Grid container spacing={2} alignItems='center' sx={{ backgroundColor: mainBlue }} px={2} py={1}>
            <Grid size='grow'>
                {isValidElement(title) ? title : (<span style={{ fontSize: '1.4rem', fontWeight: 'bold', color: 'white' }}>{title}</span>)}
            </Grid>
            {filteredActions.length > 0 && (
                <Grid container size='auto' spacing={0.5}>
                    {filteredActions.map(action => (
                        <Grid key={actions.indexOf(action)} size='auto'>
                            {isValidElement(action) ? action : (<Action {...action} color='white' />)}
                        </Grid>
                    ))}
                </Grid>
            )}
        </Grid>
    )
}

DialogActionsTitle.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    actions: PropTypes.arrayOf(PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.shape({
            icon: PropTypes.string,
            tooltip: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.element,
            ]),
            onClick: PropTypes.func,
            displayed: PropTypes.bool,
            'data-cy': PropTypes.string,
        }),
    ])),
}

export {
    DefaultDialogTitle,
}